import React, { createContext, useContext, useState } from "react";

interface Props {
  children: React.ReactNode;
}

export interface IPassersContextProps {
  passersTab: {
    search: {
      emails: string;
      report_title_date: string;
    };
  };
  setPassersTab: (s: IPassersContextProps["passersTab"]) => void;
}
const PassersContext = createContext<IPassersContextProps>({
  passersTab: {
    search: {
      emails: "",
      report_title_date: "",
    },
  },
  setPassersTab: () => ({}),
});

const PassersProvider: React.FC<Props> = ({ children }) => {
  const [passersTab, setPassersTab] = useState<IPassersContextProps["passersTab"]>({
    search: {
      emails: "",
      report_title_date: "",
    },
  });

  return (
    <PassersContext.Provider
      value={{
        passersTab,
        setPassersTab,
      }}
    >
      {children}
    </PassersContext.Provider>
  );
};

export default PassersProvider;
export const usePassersContext = (): IPassersContextProps => useContext(PassersContext);
